module.exports = __webpack_public_path__ + "8bcc6e2c52e682b21b66d80a1d41215b.svg";